export default class PaymentMethodHandler {
    constructor(modalSelector, uiManager) {
        this.modalSelector = modalSelector;
        this.uiManager = uiManager;
    }

    initializeCreditCardHandling() {
        jQuery('.wvp-credit-fields-modal').hide();

        jQuery('input[name="payment_method"]').on('change', (e) => {
            const $this = jQuery(e.currentTarget);
            jQuery('.wvp-credit-fields-modal').slideUp();

            if ($this.val() === 'vindi-pagamentos-credit' && !$this.data('token')) {
                $this.closest('.payment-method').find('.wvp-credit-fields-modal').slideDown();
                this.onPaymentMethodChange(null);
            }
        });

        jQuery('#wvp-card-number').on('input', () => {
            this.handleCardBrand();
        });
    }

    initializeCvvHandling() {
        jQuery('.saved-card-cvv').hide();

        jQuery('input[name="payment_method"]').on('change', (e) => {
            const $this = jQuery(e.currentTarget);
            jQuery('.saved-card-cvv').slideUp();

            if ($this.val() === 'vindi-pagamentos-credit' && $this.data('token')) {
                $this.closest('.saved-card').find('.saved-card-cvv').slideDown();
                this.onPaymentMethodChange($this.data('token'));
            }
        });

        jQuery('.saved-card-cvv-input').on('input', function () {
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    }

    handleCardBrand() {
        const cardField = jQuery('#wvp-card-number');
        if (!cardField.length) return;

        const cardNumber = cardField.val().replace(/\s/g, '');
        if (cardNumber.length < 6) return;

        const brands = [
            {
                code: 16,
                name: "elo",
                regex: /^(401178|401179|431274|438935|451416|457393|457631|457632|504175|506699|5067[0-6][0-9]|506777|506778|509[0-8][0-9]{2}|50999[0-8][0-9]|509999[0-9]|627780|636297|636368|636369|650003[1-3]|650003[5-9]|650004[0-9]|650005[0-1]|650405|650406|650407|650408|650409|650410[5-9]|650411[0-9]|650412[0-9]|650485|650486|650487|650488|650489|650490[0-9]|650491[0-8]|6505[0-8][0-9]|6507[0-6][0-9]|6507[7-8][0-9]|6509[0-8][0-9]{2}|650999[0-8][0-9]|6509999|65165[2-9]|65166[0-9]|655000|655[1-6][0-9]{2}|6557[0-9]{3}|6558[0-9]{3}|6559[0-8][0-9]{2}|655999|655(99[7-9]|9[8-9][0-9])|6504[0-5][0-9]{2}|65047[1-9]|6504[8-9][0-9]|650[5-6][0-9]{3}|6507[0-5][0-9]{2}|6507[8-9][0-9]{2}|650(8[0-4][0-9]{2}|850|86[0-9]{2}|870|88[0-9]{2})|65[1-5][0-9]{4}|65[6-9][0-9]{4}|6516[5-6][0-9]{2}|65167[0-9]|6517[0-8][0-9]{2}|65179[0-8][0-9]{2}|651799)/,
            },
            {
                code: 3,
                name: "visa",
                regex: /^4[0-9]{12}(?:[0-9]{3})?$/,
            },
            {
                code: 4,
                name: "mastercard",
                regex: /^5[1-5][0-9]{14}$|^2[2-7][0-9]{14}$/,
            },
            {
                code: 5,
                name: "amex",
                regex: /^3[47][0-9]{13}$/,
            },
            {
                code: 25,
                name: "hipercard",
                regex: /^(606282|3841\d{2}|60(?!11)\d{2})\d{10}$/,
            },
            {
                code: 20,
                name: "hiper",
                regex: /^(637095|637599|637612|637609|637598)\d*$/,
            },
        ];

        let found = false;

        brands.forEach((brand) => {
            if (brand.regex.test(cardNumber) && !found) {
                found = true;
                this.setCardBrand(brand.name, brand.code);
                this.onPaymentMethodChange(null);
            }
        });

        if (!found) {
            this.setCardBrand("mono/generic", 1);
            this.showInstallmentsError('Não foi possível reconhecer a bandeira do cartão.');
        }
    }

    setCardBrand(name, code) {
        const img = jQuery('#wvp-brand-icon');
        const hidden = jQuery('#wvp-card-brand');

        if (img.length) {
            const attr = img.attr('data-img');
            if (attr) {
                img.attr('src', img.attr('src').replace(attr, name));
                img.attr('data-img', name);
            }
        }

        if (hidden.length) {
            hidden.val(code);
        }
    }

    showInstallmentsError(message) {
        const errorElement = jQuery('#wvp-installments-error');
        if (errorElement.length) {
            errorElement.html(message).addClass('active');
        }
    }

    resetInstallmentsError() {
        const errorElement = jQuery('#wvp-installments-error');
        if (errorElement.length) {
            errorElement.html('').removeClass('active');
        }
    }

    // Set a callback for when payment method changes
    onPaymentMethodChange(token) {
        // This will be replaced by the main class
    }

    validateAndGetPaymentData() {
        const paymentMethod = jQuery('input[name="payment_method"]:checked');
        
        if (!paymentMethod.length) {
            return { isValid: false, message: 'Por favor, selecione uma forma de pagamento.' };
        }

        const paymentMethodValue = paymentMethod.val();
        const tokenId = paymentMethod.data('token');
        
        let cardData = {};
        
        if (paymentMethodValue === 'vindi-pagamentos-credit') {
            if (tokenId) {
                const cvv = jQuery(`#saved_card_cvv_${tokenId}`).val();
                if (!cvv) {
                    return { isValid: false, message: 'Por favor, informe o código CVV do cartão.' };
                }

                cardData = {
                    token_id: tokenId,
                    cvv: cvv,
                    last4: paymentMethod.data('last4'),
                    expiry: paymentMethod.data('expiry')
                };
            } else {
                const cardOwner = jQuery('#wvp-card-owner').val();
                const cardNumber = jQuery('#wvp-card-number').val();
                const cardDate = jQuery('#wvp-card-date').val();
                const cardCode = jQuery('#wvp-card-code').val();
                const cardBrand = jQuery('#wvp-card-brand').val();
                const installments = jQuery('#wvp-card-installments').val() || '1';

                if (!cardOwner || !cardNumber || !cardDate || !cardCode) {
                    return { isValid: false, message: 'Por favor, preencha todos os dados do cartão de crédito.' };
                }

                cardData = {
                    owner: cardOwner,
                    number: cardNumber,
                    date: cardDate,
                    code: cardCode,
                    brand: cardBrand,
                    installments: installments
                };
            }
        }
        
        return { 
            isValid: true, 
            data: {
                payment_method: paymentMethodValue,
                card_data: cardData
            }
        };
    }
}